import { render, staticRenderFns } from "./flight-check-in-status.vue?vue&type=template&id=21e18fca&scoped=true"
import script from "./flight-check-in-status.vue?vue&type=script&lang=js"
export * from "./flight-check-in-status.vue?vue&type=script&lang=js"
import style0 from "./flight-check-in-status.vue?vue&type=style&index=0&id=21e18fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e18fca",
  null
  
)

export default component.exports